export default {
    CRYPTO: {
        id: 'crypto',
        projectId: "ok-ui",
        variant: "es",
        path: "/crypto",
    },
    TRANSFERS: {
        id: 'transfers',
        projectId: "ok-ui",
        variant: "es",
        path: "/myprofile/transfers",
    }
};